import { Subject } from 'rxjs';
import { type AuthState, type UseAuthResult } from './AuthSlice.tsx';

export const AuthSubject = new Subject<AuthSubjectEvent>();

export type AuthSubjectEvent =
  // Evento di logout
  | { type: 'logout'; auth: UseAuthResult }
  // Richiesta di Refresh Token
  | {
      type: 'refresh';
      strategy: string;
      authState: AuthState;
      resolve: (data: {
        accessToken: string;
        refreshToken?: string | null;
      }) => void;
      reject: (err: Error) => void;
    };
